import { a as e, n as t } from "./mathjax-2nQh1S7u.js";
//#region ../../../node_modules/.bun/@mathjax+mathjax-newcm-font@4.1.3/node_modules/@mathjax/mathjax-newcm-font/mjs/chtml/dynamic/latin-b.js
t.dynamicSetup("", "latin-b", e({ LB: { bold: {
	192: [
		.909,
		0,
		.869
	],
	193: [
		.909,
		0,
		.869
	],
	194: [
		.893,
		0,
		.869
	],
	195: [
		.836,
		0,
		.869
	],
	196: [
		.868,
		0,
		.869
	],
	197: [
		.866,
		0,
		.869
	],
	198: [
		.686,
		0,
		1.042
	],
	199: [
		.697,
		.2,
		.831
	],
	200: [
		.909,
		0,
		.756
	],
	201: [
		.909,
		0,
		.756
	],
	202: [
		.893,
		0,
		.756
	],
	203: [
		.868,
		0,
		.756
	],
	204: [
		.909,
		0,
		.436
	],
	205: [
		.909,
		0,
		.436
	],
	206: [
		.893,
		0,
		.436
	],
	207: [
		.868,
		0,
		.436,
		{ ic: .004 }
	],
	208: [
		.686,
		0,
		.882
	],
	209: [
		.836,
		0,
		.9
	],
	210: [
		.909,
		.011,
		.864
	],
	211: [
		.909,
		.011,
		.864
	],
	212: [
		.893,
		.011,
		.864
	],
	213: [
		.836,
		.011,
		.864
	],
	214: [
		.868,
		.011,
		.864
	],
	216: [
		.746,
		.06,
		.894
	],
	217: [
		.909,
		.011,
		.885
	],
	218: [
		.909,
		.011,
		.885
	],
	219: [
		.893,
		.011,
		.885
	],
	220: [
		.868,
		.011,
		.885
	],
	221: [
		.909,
		0,
		.869
	],
	222: [
		.686,
		0,
		.724
	],
	223: [
		.7,
		.006,
		.597
	],
	224: [
		.704,
		.006,
		.559
	],
	225: [
		.704,
		.006,
		.559
	],
	226: [
		.71,
		.006,
		.559
	],
	227: [
		.661,
		.006,
		.559
	],
	228: [
		.677,
		.006,
		.559
	],
	229: [
		.689,
		.006,
		.559
	],
	230: [
		.453,
		.006,
		.831
	],
	231: [
		.453,
		.2,
		.511
	],
	232: [
		.704,
		.006,
		.527
	],
	233: [
		.704,
		.006,
		.527
	],
	234: [
		.71,
		.006,
		.527
	],
	235: [
		.677,
		.006,
		.527
	],
	236: [
		.704,
		0,
		.319
	],
	237: [
		.704,
		0,
		.319
	],
	238: [
		.71,
		0,
		.319,
		{ ic: .018 }
	],
	239: [
		.677,
		0,
		.319,
		{ ic: .039 }
	],
	241: [
		.661,
		0,
		.639
	],
	242: [
		.704,
		.006,
		.575
	],
	243: [
		.704,
		.006,
		.575
	],
	244: [
		.71,
		.006,
		.575
	],
	245: [
		.661,
		.006,
		.575
	],
	246: [
		.677,
		.006,
		.575
	],
	248: [
		.552,
		.107,
		.575
	],
	249: [
		.704,
		.006,
		.639
	],
	250: [
		.704,
		.006,
		.639
	],
	251: [
		.71,
		.006,
		.639
	],
	252: [
		.677,
		.006,
		.639
	],
	253: [
		.704,
		.2,
		.607
	],
	254: [
		.694,
		.194,
		.639
	],
	255: [
		.677,
		.2,
		.607
	],
	256: [
		.8,
		0,
		.869
	],
	257: [
		.633,
		.006,
		.559
	],
	258: [
		.925,
		0,
		.869
	],
	259: [
		.7,
		.006,
		.559
	],
	260: [
		.698,
		.206,
		.869
	],
	261: [
		.453,
		.206,
		.559
	],
	262: [
		.909,
		.011,
		.831
	],
	263: [
		.704,
		.006,
		.511
	],
	264: [
		.893,
		.011,
		.831
	],
	265: [
		.71,
		.006,
		.511
	],
	266: [
		.895,
		.011,
		.831
	],
	267: [
		.685,
		.006,
		.511
	],
	268: [
		.893,
		.011,
		.831
	],
	269: [
		.71,
		.006,
		.511
	],
	270: [
		.893,
		0,
		.882
	],
	271: [
		.694,
		.006,
		.639,
		{ ic: .063 }
	],
	272: [
		.686,
		0,
		.882
	],
	273: [
		.694,
		.006,
		.639
	],
	274: [
		.8,
		0,
		.756
	],
	275: [
		.633,
		.006,
		.527
	],
	276: [
		.925,
		0,
		.756
	],
	277: [
		.7,
		.006,
		.527
	],
	278: [
		.895,
		0,
		.756
	],
	279: [
		.685,
		.006,
		.527
	],
	280: [
		.68,
		.206,
		.756
	],
	281: [
		.453,
		.206,
		.527
	],
	282: [
		.893,
		0,
		.756
	],
	283: [
		.71,
		.006,
		.527
	],
	284: [
		.893,
		.011,
		.904
	],
	285: [
		.71,
		.201,
		.575
	],
	286: [
		.925,
		.011,
		.904
	],
	287: [
		.7,
		.201,
		.575
	],
	288: [
		.895,
		.011,
		.904
	],
	289: [
		.685,
		.201,
		.575
	],
	290: [
		.697,
		.295,
		.904
	],
	291: [
		.749,
		.201,
		.575
	],
	292: [
		.893,
		0,
		.9
	],
	293: [
		.901,
		0,
		.639
	],
	294: [
		.686,
		0,
		.9
	],
	295: [
		.694,
		0,
		.639
	],
	296: [
		.836,
		0,
		.436
	],
	297: [
		.661,
		0,
		.319,
		{ ic: .032 }
	],
	298: [
		.8,
		0,
		.436
	],
	299: [
		.633,
		0,
		.319,
		{ ic: .048 }
	],
	300: [
		.925,
		0,
		.436
	],
	301: [
		.7,
		0,
		.319,
		{ ic: .018 }
	],
	302: [
		.686,
		.206,
		.436
	],
	303: [
		.695,
		.206,
		.319
	],
	304: [
		.895,
		0,
		.436
	],
	306: [
		.686,
		.011,
		.987
	],
	307: [
		.685,
		.2,
		.639
	],
	308: [
		.893,
		.011,
		.594
	],
	309: [
		.71,
		.2,
		.351,
		{ ic: .016 }
	],
	310: [
		.686,
		.295,
		.901
	],
	311: [
		.694,
		.295,
		.607
	],
	312: [
		.452,
		0,
		.607
	],
	313: [
		.909,
		0,
		.692
	],
	314: [
		.917,
		0,
		.319,
		{ ic: .004 }
	],
	315: [
		.686,
		.295,
		.692
	],
	316: [
		.694,
		.295,
		.319
	],
	317: [
		.686,
		0,
		.692
	],
	318: [
		.694,
		0,
		.319,
		{ ic: .075 }
	],
	319: [
		.686,
		0,
		.692
	],
	320: [
		.694,
		0,
		.436
	],
	321: [
		.686,
		0,
		.692
	],
	322: [
		.694,
		0,
		.387
	],
	323: [
		.909,
		0,
		.9
	],
	324: [
		.704,
		0,
		.639
	],
	325: [
		.686,
		.295,
		.9
	],
	326: [
		.45,
		.295,
		.639
	],
	327: [
		.893,
		0,
		.9
	],
	328: [
		.71,
		0,
		.639
	],
	329: [
		.694,
		0,
		.958
	],
	330: [
		.697,
		.011,
		.9
	],
	331: [
		.45,
		.205,
		.592
	],
	332: [
		.8,
		.011,
		.864
	],
	333: [
		.633,
		.006,
		.575
	],
	334: [
		.925,
		.011,
		.864
	],
	335: [
		.7,
		.006,
		.575
	],
	336: [
		.933,
		.011,
		.864
	],
	337: [
		.704,
		.006,
		.575
	],
	338: [
		.697,
		.011,
		1.169
	],
	339: [
		.453,
		.006,
		.894
	],
	340: [
		.909,
		.011,
		.863
	],
	341: [
		.704,
		0,
		.474
	],
	342: [
		.686,
		.295,
		.863
	],
	343: [
		.45,
		.295,
		.474
	],
	344: [
		.893,
		.011,
		.863
	],
	345: [
		.71,
		0,
		.474
	],
	346: [
		.909,
		.011,
		.639
	],
	347: [
		.704,
		.006,
		.454
	],
	348: [
		.893,
		.011,
		.639
	],
	349: [
		.71,
		.006,
		.454
	],
	350: [
		.697,
		.2,
		.639
	],
	351: [
		.453,
		.2,
		.454
	],
	352: [
		.893,
		.011,
		.639
	],
	353: [
		.71,
		.006,
		.454
	],
	354: [
		.675,
		.2,
		.8
	],
	355: [
		.635,
		.2,
		.447
	],
	356: [
		.893,
		0,
		.8
	],
	357: [
		.749,
		.006,
		.447
	],
	358: [
		.675,
		0,
		.8
	],
	359: [
		.635,
		.006,
		.447
	],
	360: [
		.836,
		.011,
		.885
	],
	361: [
		.661,
		.006,
		.639
	],
	362: [
		.8,
		.011,
		.885
	],
	363: [
		.633,
		.006,
		.639
	],
	364: [
		.925,
		.011,
		.885
	],
	365: [
		.7,
		.006,
		.639
	],
	366: [
		.866,
		.011,
		.885
	],
	367: [
		.689,
		.006,
		.639
	],
	368: [
		.933,
		.011,
		.885
	],
	369: [
		.704,
		.006,
		.639
	],
	370: [
		.686,
		.206,
		.885
	],
	371: [
		.45,
		.206,
		.639
	],
	372: [
		.893,
		.008,
		1.189
	],
	373: [
		.71,
		.004,
		.831
	],
	374: [
		.893,
		0,
		.869
	],
	375: [
		.71,
		.2,
		.607
	],
	376: [
		.868,
		0,
		.869
	],
	377: [
		.909,
		0,
		.703
	],
	378: [
		.704,
		0,
		.511
	],
	379: [
		.895,
		0,
		.703
	],
	380: [
		.685,
		0,
		.511
	],
	381: [
		.893,
		0,
		.703
	],
	382: [
		.71,
		0,
		.511
	],
	383: [
		.7,
		0,
		.351,
		{ ic: .086 }
	],
	384: [
		.695,
		.005,
		.639
	],
	385: [
		.686,
		0,
		.985
	],
	386: [
		.686,
		0,
		.818
	],
	387: [
		.686,
		.006,
		.639
	],
	388: [
		.694,
		0,
		.818
	],
	389: [
		.694,
		.006,
		.639
	],
	390: [
		.697,
		.011,
		.83
	],
	391: [
		.792,
		.011,
		.871,
		{ ic: .081 }
	],
	392: [
		.649,
		.005,
		.575,
		{ ic: .079 }
	],
	393: [
		.686,
		0,
		.882
	],
	394: [
		.686,
		0,
		1.049
	],
	395: [
		.686,
		0,
		.818
	],
	396: [
		.688,
		.006,
		.639
	],
	397: [
		.544,
		.165,
		.594
	],
	398: [
		.68,
		0,
		.756
	],
	399: [
		.697,
		.011,
		.795
	],
	400: [
		.697,
		.011,
		.703
	],
	401: [
		.68,
		.205,
		.724
	],
	402: [
		.7,
		0,
		.351,
		{ ic: .086 }
	],
	403: [
		.792,
		.011,
		.871,
		{ ic: .08 }
	],
	404: [
		.682,
		.205,
		.808
	],
	405: [
		.695,
		.005,
		.882
	],
	406: [
		.683,
		.009,
		.355
	],
	407: [
		.686,
		0,
		.436
	],
	408: [
		.701,
		0,
		.925
	],
	409: [
		.7,
		0,
		.607
	],
	410: [
		.695,
		0,
		.447
	],
	411: [
		.695,
		.009,
		.607
	],
	412: [
		.688,
		.006,
		.833
	],
	413: [
		.686,
		.205,
		.9
	],
	414: [
		.45,
		.195,
		.607,
		{ ic: .009 }
	],
	415: [
		.697,
		.011,
		.864
	],
	416: [
		.819,
		.011,
		.864
	],
	417: [
		.578,
		.006,
		.575
	],
	418: [
		.709,
		.202,
		.964
	],
	419: [
		.466,
		.197,
		.739
	],
	420: [
		.686,
		0,
		.954
	],
	421: [
		.7,
		.195,
		.607
	],
	422: [
		.686,
		.18,
		.863
	],
	423: [
		.697,
		.01,
		.639
	],
	424: [
		.453,
		.006,
		.454
	],
	425: [
		.686,
		0,
		.831
	],
	426: [
		.7,
		.2,
		.391,
		{ ic: .03 }
	],
	427: [
		.635,
		.2,
		.479
	],
	428: [
		.675,
		0,
		.8
	],
	429: [
		.63,
		.005,
		.479
	],
	430: [
		.675,
		.225,
		.8
	],
	431: [
		.819,
		.011,
		.885
	],
	432: [
		.578,
		.006,
		.671,
		{ ic: .016 }
	],
	433: [
		.697,
		0,
		.831
	],
	434: [
		.686,
		.022,
		.724
	],
	435: [
		.686,
		0,
		.954
	],
	436: [
		.453,
		.2,
		.702
	],
	437: [
		.686,
		0,
		.703
	],
	438: [
		.444,
		0,
		.511
	],
	439: [
		.686,
		.011,
		.639
	],
	440: [
		.686,
		.011,
		.639
	],
	441: [
		.445,
		.2,
		.511
	],
	442: [
		.445,
		.2,
		.511
	],
	443: [
		.655,
		0,
		.575
	],
	444: [
		.675,
		.011,
		.575
	],
	445: [
		.445,
		.2,
		.511
	],
	446: [
		.635,
		.006,
		.454
	],
	447: [
		.47,
		.236,
		.575
	],
	448: [
		.695,
		.195,
		.319
	],
	449: [
		.695,
		.195,
		.511
	],
	450: [
		.695,
		.195,
		.639
	],
	451: [
		.705,
		0,
		.35
	],
	452: [
		.904,
		0,
		1.585
	],
	453: [
		.686,
		0,
		1.393
	],
	454: [
		.694,
		.006,
		1.15
	],
	455: [
		.686,
		.011,
		1.285
	],
	456: [
		.695,
		.2,
		1.042
	],
	457: [
		.695,
		.2,
		.67
	],
	458: [
		.686,
		.011,
		1.494
	],
	459: [
		.695,
		.2,
		1.251
	],
	460: [
		.695,
		.2,
		.99
	],
	461: [
		.893,
		0,
		.869
	],
	462: [
		.71,
		.006,
		.559
	],
	463: [
		.893,
		0,
		.436
	],
	464: [
		.71,
		0,
		.319,
		{ ic: .018 }
	],
	465: [
		.893,
		.011,
		.864
	],
	466: [
		.71,
		.006,
		.575
	],
	467: [
		.893,
		.011,
		.885
	],
	468: [
		.71,
		.006,
		.639
	],
	469: [
		1.098,
		.011,
		.885
	],
	470: [
		.822,
		.006,
		.639
	],
	471: [
		1.091,
		.011,
		.885
	],
	472: [
		.9,
		.006,
		.639
	],
	473: [
		1.075,
		.011,
		.885
	],
	474: [
		.884,
		.006,
		.639
	],
	475: [
		1.091,
		.011,
		.885
	],
	476: [
		.9,
		.006,
		.639
	],
	477: [
		.453,
		.006,
		.527
	],
	478: [
		1.078,
		0,
		.869
	],
	479: [
		.842,
		.006,
		.559
	],
	480: [
		1.066,
		0,
		.869
	],
	481: [
		.802,
		.006,
		.559
	],
	482: [
		.842,
		0,
		1.041
	],
	483: [
		.604,
		.005,
		.83
	],
	484: [
		.697,
		.011,
		.904
	],
	485: [
		.455,
		.201,
		.575
	],
	486: [
		.893,
		.011,
		.904
	],
	487: [
		.71,
		.201,
		.575
	],
	488: [
		.894,
		0,
		.901
	],
	489: [
		.905,
		0,
		.606
	],
	490: [
		.697,
		.206,
		.864
	],
	491: [
		.453,
		.206,
		.575
	],
	492: [
		.866,
		.206,
		.864
	],
	493: [
		.631,
		.206,
		.575
	],
	494: [
		.894,
		.011,
		.639
	],
	495: [
		.664,
		.2,
		.511
	],
	496: [
		.71,
		.2,
		.351,
		{ ic: .016 }
	],
	497: [
		.686,
		0,
		1.585
	],
	498: [
		.686,
		0,
		1.393
	],
	499: [
		.694,
		.006,
		1.15
	],
	500: [
		.909,
		.011,
		.904
	],
	501: [
		.704,
		.201,
		.575
	],
	502: [
		.686,
		.012,
		1.178
	],
	503: [
		.72,
		.228,
		.66
	],
	504: [
		.875,
		0,
		.9
	],
	505: [
		.662,
		0,
		.638
	],
	506: [
		1.072,
		0,
		.869
	],
	507: [
		.895,
		.006,
		.559
	],
	508: [
		.909,
		0,
		1.042
	],
	509: [
		.704,
		.006,
		.831
	],
	510: [
		.909,
		.06,
		.894
	],
	511: [
		.704,
		.107,
		.575
	],
	512: [
		.933,
		0,
		.869
	],
	513: [
		.704,
		.006,
		.559
	],
	514: [
		.894,
		0,
		.869
	],
	515: [
		.653,
		.006,
		.559
	],
	516: [
		.933,
		0,
		.756
	],
	517: [
		.704,
		.006,
		.527
	],
	518: [
		.894,
		0,
		.755
	],
	519: [
		.653,
		.006,
		.527
	],
	520: [
		.933,
		0,
		.436
	],
	521: [
		.704,
		0,
		.319
	],
	522: [
		.894,
		0,
		.436
	],
	523: [
		.653,
		0,
		.319,
		{ ic: .028 }
	],
	524: [
		.933,
		.011,
		.864
	],
	525: [
		.704,
		.006,
		.575
	],
	526: [
		.894,
		.011,
		.863
	],
	527: [
		.653,
		.006,
		.575
	],
	528: [
		.933,
		.011,
		.863
	],
	529: [
		.704,
		0,
		.474
	],
	530: [
		.894,
		.011,
		.862
	],
	531: [
		.653,
		0,
		.473
	],
	532: [
		.933,
		.011,
		.885
	],
	533: [
		.704,
		.006,
		.639
	],
	534: [
		.894,
		.011,
		.884
	],
	535: [
		.653,
		.006,
		.638
	],
	536: [
		.697,
		.295,
		.639
	],
	537: [
		.453,
		.295,
		.454
	],
	538: [
		.675,
		.295,
		.8
	],
	539: [
		.635,
		.295,
		.447
	],
	540: [
		.683,
		-.001,
		.487
	],
	541: [
		.473,
		.209,
		.487
	],
	542: [
		.894,
		0,
		.9
	],
	543: [
		.905,
		0,
		.638
	],
	544: [
		.71,
		.2,
		.829
	],
	545: [
		.695,
		.163,
		.703
	],
	546: [
		.699,
		.02,
		.552
	],
	547: [
		.659,
		.02,
		.548
	],
	548: [
		.686,
		.174,
		.733
	],
	549: [
		.445,
		.174,
		.575
	],
	550: [
		.902,
		0,
		.869
	],
	551: [
		.694,
		.006,
		.559
	],
	552: [
		.68,
		.196,
		.756
	],
	553: [
		.453,
		.204,
		.527
	],
	554: [
		1.098,
		.011,
		.864
	],
	555: [
		.829,
		.006,
		.575
	],
	556: [
		1.038,
		.011,
		.864
	],
	557: [
		.829,
		.006,
		.575
	],
	558: [
		.902,
		.011,
		.863
	],
	559: [
		.694,
		.006,
		.575
	],
	560: [
		1.058,
		.011,
		.863
	],
	561: [
		.829,
		.006,
		.575
	],
	562: [
		.842,
		0,
		.869
	],
	563: [
		.604,
		.2,
		.606
	],
	564: [
		.694,
		.159,
		.431
	],
	565: [
		.45,
		.163,
		.703
	],
	566: [
		.635,
		.159,
		.447
	],
	568: [
		.695,
		.006,
		.958
	],
	569: [
		.45,
		.195,
		.958
	],
	570: [
		.782,
		.083,
		.869
	],
	571: [
		.782,
		.083,
		.869
	],
	572: [
		.503,
		.083,
		.555
	],
	573: [
		.686,
		0,
		.692
	],
	574: [
		.782,
		.083,
		.8
	],
	575: [
		.453,
		.242,
		.454
	],
	576: [
		.444,
		.227,
		.511
	],
	577: [
		.7,
		0,
		.575
	],
	578: [
		.46,
		0,
		.575
	],
	579: [
		.686,
		0,
		.818
	],
	580: [
		.686,
		.011,
		.885
	],
	581: [
		.694,
		0,
		.869
	],
	582: [
		.782,
		.083,
		.756
	],
	583: [
		.503,
		.083,
		.527
	],
	584: [
		.686,
		.011,
		.64
	],
	585: [
		.685,
		.2,
		.351,
		{ ic: .012 }
	],
	586: [
		.681,
		.225,
		1.032
	],
	587: [
		.45,
		.206,
		.684,
		{ ic: .041 }
	],
	588: [
		.686,
		.011,
		.863
	],
	589: [
		.45,
		0,
		.474
	],
	590: [
		.686,
		0,
		.869
	],
	591: [
		.444,
		.2,
		.607
	],
	11377: [
		.45,
		.008,
		.685
	],
	7680: [
		.698,
		.23,
		.869
	],
	7681: [
		.453,
		.23,
		.559
	],
	7682: [
		.902,
		0,
		.818
	],
	7683: [
		.935,
		.006,
		.638
	],
	7684: [
		.686,
		.196,
		.818
	],
	7685: [
		.694,
		.217,
		.638
	],
	7686: [
		.686,
		.143,
		.818
	],
	7687: [
		.694,
		.166,
		.638
	],
	7688: [
		.875,
		.199,
		.83
	],
	7689: [
		.662,
		.199,
		.511
	],
	7690: [
		.902,
		0,
		.881
	],
	7691: [
		.935,
		.006,
		.638
	],
	7692: [
		.686,
		.2,
		.882
	],
	7693: [
		.694,
		.2,
		.639
	],
	7694: [
		.686,
		.148,
		.882
	],
	7695: [
		.694,
		.148,
		.639
	],
	7696: [
		.686,
		.199,
		.881
	],
	7697: [
		.694,
		.199,
		.638
	],
	7698: [
		.686,
		.211,
		.881
	],
	7699: [
		.694,
		.24,
		.638
	],
	7704: [
		.68,
		.211,
		.755
	],
	7705: [
		.453,
		.24,
		.527
	],
	7706: [
		.68,
		.155,
		.755
	],
	7707: [
		.453,
		.164,
		.527
	],
	7710: [
		.902,
		0,
		.723
	],
	7711: [
		.935,
		0,
		.351,
		{ ic: .086 }
	],
	7712: [
		.842,
		.011,
		.904
	],
	7713: [
		.604,
		.201,
		.575
	],
	7714: [
		.902,
		0,
		.9
	],
	7715: [
		.935,
		0,
		.638
	],
	7716: [
		.686,
		.2,
		.9
	],
	7717: [
		.694,
		.2,
		.639
	],
	7718: [
		.868,
		0,
		.9
	],
	7719: [
		.876,
		0,
		.639
	],
	7722: [
		.686,
		.215,
		.9
	],
	7723: [
		.694,
		.215,
		.639
	],
	7724: [
		.686,
		.155,
		.436,
		{ ic: .005 }
	],
	7725: [
		.695,
		.164,
		.319,
		{ ic: .042 }
	],
	7726: [
		1.091,
		0,
		.436,
		{ ic: .004 }
	],
	7727: [
		.9,
		0,
		.319,
		{ ic: .039 }
	],
	7728: [
		.875,
		0,
		.901
	],
	7729: [
		.903,
		0,
		.606
	],
	7730: [
		.686,
		.196,
		.901
	],
	7731: [
		.694,
		.217,
		.606
	],
	7732: [
		.686,
		.143,
		.901
	],
	7733: [
		.694,
		.166,
		.606
	],
	7734: [
		.686,
		.2,
		.692
	],
	7735: [
		.694,
		.2,
		.319
	],
	7736: [
		.8,
		.2,
		.692
	],
	7737: [
		.808,
		.2,
		.319,
		{ ic: .054 }
	],
	7738: [
		.686,
		.143,
		.691
	],
	7739: [
		.694,
		.166,
		.319,
		{ ic: .059 }
	],
	7740: [
		.686,
		.211,
		.691
	],
	7741: [
		.694,
		.24,
		.319,
		{ ic: .009 }
	],
	7742: [
		.875,
		0,
		1.091
	],
	7743: [
		.662,
		0,
		.958
	],
	7744: [
		.902,
		0,
		1.091
	],
	7745: [
		.694,
		0,
		.958
	],
	7746: [
		.686,
		.2,
		1.092
	],
	7747: [
		.45,
		.2,
		.958
	],
	7748: [
		.884,
		0,
		.9
	],
	7749: [
		.685,
		0,
		.639
	],
	7750: [
		.686,
		.2,
		.9
	],
	7751: [
		.45,
		.2,
		.639
	],
	7752: [
		.686,
		.143,
		.9
	],
	7753: [
		.45,
		.166,
		.638
	],
	7754: [
		.686,
		.211,
		.9
	],
	7755: [
		.45,
		.24,
		.638
	],
	7764: [
		.875,
		0,
		.786
	],
	7765: [
		.662,
		.194,
		.638
	],
	7766: [
		.902,
		0,
		.786
	],
	7767: [
		.694,
		.194,
		.638
	],
	7768: [
		.895,
		.011,
		.863
	],
	7769: [
		.685,
		0,
		.474
	],
	7770: [
		.686,
		.2,
		.863
	],
	7771: [
		.45,
		.2,
		.474
	],
	7772: [
		.8,
		.2,
		.863
	],
	7773: [
		.633,
		.2,
		.474
	],
	7774: [
		.686,
		.143,
		.862
	],
	7775: [
		.45,
		.166,
		.473
	],
	7776: [
		.902,
		.011,
		.638
	],
	7777: [
		.694,
		.006,
		.453
	],
	7778: [
		.697,
		.2,
		.639
	],
	7779: [
		.453,
		.2,
		.454
	],
	7784: [
		.902,
		.196,
		.638
	],
	7785: [
		.694,
		.217,
		.453
	],
	7786: [
		.902,
		0,
		.8
	],
	7787: [
		.876,
		.006,
		.447
	],
	7788: [
		.675,
		.2,
		.8
	],
	7789: [
		.635,
		.2,
		.447
	],
	7790: [
		.675,
		.148,
		.8
	],
	7791: [
		.635,
		.148,
		.447
	],
	7792: [
		.675,
		.211,
		.8
	],
	7793: [
		.635,
		.24,
		.447
	],
	7794: [
		.686,
		.196,
		.884
	],
	7795: [
		.45,
		.218,
		.638
	],
	7796: [
		.686,
		.155,
		.884
	],
	7797: [
		.45,
		.164,
		.638
	],
	7798: [
		.686,
		.211,
		.884
	],
	7799: [
		.45,
		.24,
		.638
	],
	7804: [
		.894,
		.008,
		.869
	],
	7805: [
		.632,
		.004,
		.606
	],
	7806: [
		.686,
		.196,
		.869
	],
	7807: [
		.444,
		.217,
		.606
	],
	7808: [
		.909,
		.008,
		1.189
	],
	7809: [
		.704,
		.004,
		.831
	],
	7810: [
		.909,
		.008,
		1.189
	],
	7811: [
		.704,
		.004,
		.831
	],
	7812: [
		.868,
		.008,
		1.189
	],
	7813: [
		.677,
		.004,
		.831
	],
	7814: [
		.902,
		.008,
		1.188
	],
	7815: [
		.694,
		.004,
		.83
	],
	7816: [
		.686,
		.196,
		1.188
	],
	7817: [
		.444,
		.217,
		.83
	],
	7818: [
		.902,
		0,
		.869
	],
	7819: [
		.694,
		0,
		.606
	],
	7820: [
		.894,
		0,
		.869
	],
	7821: [
		.686,
		0,
		.606
	],
	7822: [
		.902,
		0,
		.869
	],
	7823: [
		.694,
		.2,
		.606
	],
	7824: [
		.9,
		0,
		.702
	],
	7825: [
		.658,
		0,
		.511
	],
	7826: [
		.686,
		.2,
		.703
	],
	7827: [
		.444,
		.2,
		.511
	],
	7828: [
		.686,
		.143,
		.702
	],
	7829: [
		.444,
		.166,
		.511
	],
	7830: [
		.694,
		.166,
		.638
	],
	7831: [
		.826,
		.006,
		.447
	],
	7832: [
		.661,
		.004,
		.83
	],
	7833: [
		.661,
		.2,
		.606
	],
	7835: [
		.935,
		0,
		.351,
		{ ic: .086 }
	],
	7838: [
		.7,
		.006,
		.665
	],
	7840: [
		.698,
		.2,
		.869
	],
	7841: [
		.453,
		.2,
		.559
	],
	7842: [
		.932,
		0,
		.869
	],
	7843: [
		.703,
		.006,
		.559
	],
	7844: [
		1.099,
		0,
		.869
	],
	7845: [
		.874,
		.006,
		.559
	],
	7846: [
		1.099,
		0,
		.869
	],
	7847: [
		.874,
		.006,
		.559
	],
	7848: [
		1.101,
		0,
		.869
	],
	7849: [
		.876,
		.006,
		.559
	],
	7850: [
		1.056,
		0,
		.869
	],
	7851: [
		.831,
		.006,
		.559
	],
	7852: [
		.893,
		.2,
		.869
	],
	7853: [
		.71,
		.2,
		.559
	],
	7854: [
		1.131,
		0,
		.869
	],
	7855: [
		.907,
		.006,
		.559
	],
	7856: [
		1.131,
		0,
		.869
	],
	7857: [
		.907,
		.006,
		.559
	],
	7858: [
		1.133,
		0,
		.869
	],
	7859: [
		.909,
		.006,
		.559
	],
	7860: [
		1.088,
		0,
		.869
	],
	7861: [
		.864,
		.006,
		.559
	],
	7862: [
		.925,
		.2,
		.869
	],
	7863: [
		.7,
		.2,
		.559
	],
	7864: [
		.68,
		.2,
		.756
	],
	7865: [
		.453,
		.2,
		.527
	],
	7866: [
		.932,
		0,
		.756
	],
	7867: [
		.703,
		.006,
		.527
	],
	7868: [
		.836,
		0,
		.756
	],
	7869: [
		.661,
		.006,
		.527
	],
	7870: [
		1.099,
		0,
		.756
	],
	7871: [
		.874,
		.006,
		.527
	],
	7872: [
		1.099,
		0,
		.756
	],
	7873: [
		.874,
		.006,
		.527
	],
	7874: [
		1.101,
		0,
		.756
	],
	7875: [
		.876,
		.006,
		.527
	],
	7876: [
		1.056,
		0,
		.756
	],
	7877: [
		.831,
		.006,
		.527
	],
	7878: [
		.893,
		.2,
		.756
	],
	7879: [
		.71,
		.2,
		.527
	],
	7880: [
		.932,
		0,
		.436
	],
	7881: [
		.703,
		0,
		.319
	],
	7882: [
		.686,
		.2,
		.436
	],
	7883: [
		.685,
		.2,
		.319
	],
	7884: [
		.697,
		.2,
		.864
	],
	7885: [
		.453,
		.2,
		.575
	],
	7886: [
		.932,
		.011,
		.864
	],
	7887: [
		.703,
		.006,
		.575
	],
	7888: [
		1.099,
		.011,
		.864
	],
	7889: [
		.874,
		.006,
		.575
	],
	7890: [
		1.099,
		.011,
		.864
	],
	7891: [
		.874,
		.006,
		.575
	],
	7892: [
		1.101,
		.011,
		.864
	],
	7893: [
		.876,
		.006,
		.575
	],
	7894: [
		1.056,
		.011,
		.864
	],
	7895: [
		.831,
		.006,
		.575
	],
	7896: [
		.893,
		.2,
		.864
	],
	7897: [
		.71,
		.2,
		.575
	],
	7898: [
		.909,
		.011,
		.864
	],
	7899: [
		.704,
		.006,
		.575
	],
	7900: [
		.909,
		.011,
		.864
	],
	7901: [
		.704,
		.006,
		.575
	],
	7902: [
		.932,
		.011,
		.864
	],
	7903: [
		.703,
		.006,
		.575
	],
	7904: [
		.836,
		.011,
		.864
	],
	7905: [
		.661,
		.006,
		.575
	],
	7906: [
		.819,
		.2,
		.864
	],
	7907: [
		.578,
		.2,
		.575
	],
	7908: [
		.686,
		.2,
		.885
	],
	7909: [
		.45,
		.2,
		.639
	],
	7910: [
		.932,
		.011,
		.885
	],
	7911: [
		.703,
		.006,
		.639
	],
	7912: [
		.909,
		.011,
		.885
	],
	7913: [
		.704,
		.006,
		.671,
		{ ic: .016 }
	],
	7914: [
		.909,
		.011,
		.885
	],
	7915: [
		.704,
		.006,
		.671,
		{ ic: .016 }
	],
	7916: [
		.932,
		.011,
		.885
	],
	7917: [
		.703,
		.006,
		.671,
		{ ic: .016 }
	],
	7918: [
		.836,
		.011,
		.885
	],
	7919: [
		.661,
		.006,
		.671,
		{ ic: .016 }
	],
	7920: [
		.819,
		.2,
		.885
	],
	7921: [
		.578,
		.2,
		.671,
		{ ic: .016 }
	],
	7922: [
		.909,
		0,
		.869
	],
	7923: [
		.704,
		.2,
		.607
	],
	7924: [
		.686,
		.2,
		.869
	],
	7925: [
		.444,
		.2,
		.607
	],
	7926: [
		.932,
		0,
		.869
	],
	7927: [
		.703,
		.2,
		.607
	],
	7928: [
		.836,
		0,
		.869
	],
	7929: [
		.661,
		.2,
		.607
	]
} } }, "NCM"), {}, ["MJX-NCM-LB"]);
//#endregion
